import React from "react";
import { UseFormReturn } from "react-hook-form";
import { DrawerHeader } from "@/components/ui/drawer";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Step } from "./constants";
import Card from "@/components/custom/card";
import { useTranslation } from "react-i18next";
import { INVOICE_STATUS } from "@/lib/constants";
import { InvoiceFormValues } from "./";

const StatusStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<InvoiceFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <DrawerHeader
        title={t("title.status")}
        leftButton={
          <button
            type="button"
            onClick={() => setStep(Step.INITAL)}
            className="w-6"
          >
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-6" />}
      />

      <p className="mx-auto max-w-[210px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.select_status")}
      </p>

      <div className="mt-5 space-y-[15px]">
        {INVOICE_STATUS?.map((status) => (
          <Card
            data-testid={`invoice-form-status-item-${status.value}`}
            onClick={() => {
              form.setValue("status", status.value.toString());
              setStep(Step.INITAL);
            }}
            className="px-[15px] py-[14px]"
            key={status.value}
          >
            <div className="flex flex-col items-start justify-between gap-3">
              <span className="text-[15px] font-medium leading-[18px] text-white">
                {t(`invoice_status.${status.translationKey}`)}
              </span>
            </div>
            <CaretRight color="#E3EDFC" size={18} />
          </Card>
        ))}
      </div>
    </div>
  );
};

export default StatusStep;
